
//include 10
jQuery(function(){

    var privateFunctions = {
        /*
        alreadyRated(id) {
            if (!id)
                return false;
            var rating = window.pixelpoint.sessionService.get("rating-" + id);
            return !!rating;
        },        
        sendRating(id, rating, callback) {
            if (!id)
                return;
            //here we send the rating, probably some ajax call
            window.pixelpoint.sessionService.set("rating-" + id, rating);
            if (!!callback)
                callback();
        }
        //*/
        sendRating(pp_id, pp_type, rating, callback) {

            var ratingEndpoint = window.pixelpoint.utilities.getAjaxUrl(`/index.php?type=1732176051&action=rate`);
            $.ajax({
                url: ratingEndpoint,
                type: "POST",
                data: {
                    "pp_id": pp_id,
                    "pp_type": pp_type,
                    "value": rating
                },
                success: function (data) {
                    if (!!callback)
                        callback(data.success);
                },
                error: function () {
                    if (!!callback)
                        callback(false);
                }
            });
        }
    };

    $("[data-ratings]").each(function () {

        var $this = $(this);
        var parent = $this.closest(".rate");

        var lityInstance = null;

        $this.find(".heart").on("mouseover", function () {
            if (parent.hasClass("inactive")) {
                return;
            }
            $(this).prevAll().addClass("hovered");
            $(this).addClass("hovered");

        });
        $this.find(".heart").on("mouseleave", function () {
            if (parent.hasClass("inactive")) {
                return;
            }
            $this.find(".heart").removeClass("hovered");
        });

        //the cancel action will be the same on every click
        parent.find(".rating-confirm .cancel").on("click touchstart",function(){
            if(lityInstance != null){
                lityInstance.close();
                lityInstance = null;
            }
        });

        $this.find(".heart").on("click touchstart", function () {
            if (parent.hasClass("inactive")) {
                return;
            }

            var rating = $this.find(".heart.hovered").length;
            if(rating == 0){
                rating = $(this).closest(".heart").index() + 1;
            }
            var pp_id = $this.data("pp-id");
            var pp_type = $this.data("pp-type");

            if (!rating || !pp_id || !pp_type)
                return;

            var heart = $(this);

            if(parent.find(".rating-confirm .confirm-message .rate-count").length == 0){
                let currentText = parent.find(".rating-confirm .confirm-message").text();
                currentText = currentText.replace("%s",rating);
                parent.find(".rating-confirm .confirm-message").text(currentText);
            }
            else{
                parent.find(".rating-confirm .confirm-message .rate-count").text(rating);
            }           

            parent.find(".rating-confirm .confirm").off("click touchstart").on("click touchstart",function(){
                heart.prevAll().addClass("hovered");
                heart.addClass("hovered");

                privateFunctions.sendRating(pp_id, pp_type, rating, function (success) {
                    if (success) {
                        parent.addClass("inactive");
                    }
                    window.pixelpoint.modal.open(window.ppt.translate("rating.success","Vielen Dank für Ihre Bewertung. Diese wird in den kommenden Stunden auch für andere Nutzer sichtbar."),window.ppt.translate("rating.success.title","Ihre Bewertung wurde abgegeben"));
                });

                if(lityInstance != null){
                    lityInstance.close();
                    lityInstance = null;
                }
            });

            lityInstance = lity(".rating-confirm",{
                esc:false,
                template:'<div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>'
            });

        });        
    });

    $(".rating-wrapper .item.bewertung").on("click",(evt) => {
       let idSelector = $(evt.target).closest("a").attr("href");
       if($(idSelector).length > 0)
        lity($(idSelector));
    });
});